



























import {Component, Vue, Prop, PropSync} from 'vue-property-decorator'
import DButton from '@/components/DButton/button.vue';

import {AppModule} from '@/store/modules/app'

import {
    DxPopup
} from 'devextreme-vue';


@Component({
    name: 'connectionLostPopup',
    components: {
        DxPopup,
        DButton,
    }
})
export default class extends Vue {

    private state = AppModule;

    created() {

    }

    beforeDestroy() {
    }
}
